import { createSelector } from '@ngrx/store';

import * as Utils from '@shared/core/utils';

import { getLocationDetails } from '../getLocationDetails';

const groupByDayOfWeek = (nextWeek: APICommon.LocationOrderingTimeInfoExtendedModel[]) =>
    nextWeek.reduce((acc, day) => {
        const dayOfWeek = day.DayOfWeek;
        if (!acc[dayOfWeek]) {
            acc[dayOfWeek] = [];
        }
        acc[dayOfWeek].push(day);

        return acc;
    }, {} as Record<number, APICommon.LocationOrderingTimeInfoExtendedModel[]>);

export const getLocationOperatingHours = (locationNo: number) =>
    createSelector(getLocationDetails(locationNo), (location) => {
        const result =
            location?.OperatingTimeInfo?.map((operatingTimeInfo) => ({
                ...operatingTimeInfo,
                IsOpen: new Utils.LocationOpenStatus(operatingTimeInfo).isOpen(),
            })) || null;

        if (!result) {
            return null;
        }

        const { today, oneWeekLater } = Utils.Dates.getOneWeekLaterFromNow();
        const nextWeek = result.filter((day) => Utils.Dates.isDateWithinRange(new Date(day.Date), today, oneWeekLater));
        const groupedByDay = groupByDayOfWeek(nextWeek);

        Object.values(groupedByDay).forEach((dayHours) => dayHours.sort((a, b) => a.OpeningTime.localeCompare(b.OpeningTime)));

        return Array.from({ length: 7 }, (_, index) => groupedByDay[(index + today.getDay()) % 7] || []);
    });
